var WDN = WDN || {};

if (typeof WDN.CartUpsell === "undefined") {
  WDN.CartUpsell = (function () {
    class CartUpsell extends HTMLElement {
      constructor() {
        super();
        this.variantID = this.getAttribute("data-variant-id");
        this.inCart = this.getAttribute("data-in-cart") === "true";
        this.submit = this.querySelector(".btn");

        if (this.inCart) return;
        this.submit.addEventListener("click", this.onClick.bind(this));
      }

      onAdd(res) {
        // fire events
        var cart = document.querySelector("wdn-cart");
        if (!cart) return;
        cart.reloadCart();
      }

      onAddError() {}

      onClick() {
        WDN.Cart.Add({
          data: {
            id: this.variantID,
            quantity: 1,
            properties: {
              _cartGift: true,
            },
          },
          onSuccess: this.onAdd.bind(this),
          onError: this.onAddError.bind(this),
        });
      }
    }

    customElements.define("cart-upsell", CartUpsell);

    return CartUpsell;
  })();
}
